import { render, staticRenderFns } from "./BlockRole.vue?vue&type=template&id=acaf9446&scoped=true"
import script from "./BlockRole.vue?vue&type=script&lang=ts"
export * from "./BlockRole.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acaf9446",
  null
  
)

export default component.exports